export const fetchCustomerTestimonialsData = async () => {
  try {
      const headers = new Headers({
          "cache-control": "max-age=172800"
      })
    const response = await fetch('./content/about/page-components/article/testimonials.json', {
        headers: headers
    });
    const customerTestimonialsData = await response.json();
    return customerTestimonialsData;
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchCustomerTestimonialsData.js